import React from 'react'

function Footer() {

  return (
    <div className='footer'>
        <div className='footer__text'>Designed by Youngeun Suh</div>
        <div className='footer__text'>© 2024 All rights reserved by Youngeun Suh.</div>
    </div>
  )
}

export default Footer